import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosInstance';
import DynamicDataTable from '../components/DynamicDataTable';
import { StatusEnum } from '../assets/common';

const TestPage = () => {
    const [data, setData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    const [loading, setLoading] = useState(false);

    const columns = [
        {
            field: 'id',
            header: 'ID',
            sortable: true,
        },
        {
            field: 'status',
            header: 'Durum',
            sortable: true,
            sortField: 'status',
            body: (rowData) => rowData.status ? rowData.status.value : '',
        },
        {
            field: 'name',
            header: 'Ad',
            sortable: true,
        },
        {
            field: 'surname',
            header: 'Soyad',
            sortable: true,
        },
        {
            field: 'dateOfRecorded',
            header: 'Kayıt Tarihi',
            sortable: true,
            body: (rowData) =>
                rowData.dateOfRecorded ? new Date(rowData.dateOfRecorded).toLocaleString() : '',
        },
    ];

    useEffect(() => {
    }, []);

    const filterFields = [
        {
            field: 'status',
            label: 'Durum',
            type: 'dropdown',
            options: StatusEnum,
            optionLabel: 'value',
            optionValue: 'value',
            placeholder: 'Durum Seçiniz',
        },
        {
            field: 'name',
            label: 'Ad',
            type: 'text',
        },
        {
            field: 'surname',
            label: 'Soyad',
            type: 'text',
        },
        {
            field: 'dateOfRecorded',
            label: 'Kayıt Tarihi',
            type: 'date',
            placeholder: 'Tarih Aralığı Seçiniz',
        },
    ];

    const onLoadData = async (lazyParams, filters) => {
        setLoading(true);
        const { first, rows, sortField, sortOrder } = lazyParams;
        const pageNumber = first / rows;
        const pageSize = rows;

        const requestBody = {
            filter: prepareFiltersForBackend(filters),
            pageNumber: pageNumber,
            pageSize: pageSize,
            sortField: sortField,
            sortOrder: sortOrder === 1 ? 'ASC' : sortOrder === -1 ? 'DESC' : null,
        };

        try {
            const response = await axiosInstance.post('/api/tests/paged', requestBody);

            setData(response.data.content || []);
            setTotalRecords(response.data.totalElements || 0);
            setLoading(false);
        } catch (error) {
            console.error('Veriler yüklenirken hata oluştu:', error);
            setLoading(false);
        }
    };

    const prepareFiltersForBackend = (filters) => {
        const preparedFilters = {};

        for (const key in filters) {
            const filterValue = filters[key];
            if (filterValue) {
                if (Array.isArray(filterValue) && filterValue.length === 2) {
                    preparedFilters[key] = {
                        from: filterValue[0],
                        to: filterValue[1],
                    };
                } else {
                    preparedFilters[key] = filterValue;
                }
            }
        }

        return preparedFilters;
    };

    return (
        <div className="p-m-4">
            <h1>Test Sayfası</h1>
            <DynamicDataTable
                columns={columns}
                filterFields={filterFields}
                data={data}
                totalRecords={totalRecords}
                loading={loading}
                onLoadData={onLoadData}
            />
        </div>
    );
};

export default TestPage;
